import React from "react";
import Hero from "../components/Hero";
import { Link } from "react-router-dom";
import Services from "../components/HomePage/Services";

import Categories from "../components/Categories";

export default function HomePage() {
  return (
    <>
      <Hero title="Her starter din smagsrejse" max="true">
        <Link to="/products" className="main-link" style={{ margin: "2rem" }}>
          Menu
        </Link>
      </Hero>

      <Categories></Categories>
      <Services></Services>
    </>
  );
}
